import React from 'react';
import { Button, Space, Typography } from 'antd';
import { CalendarOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { CustomerInfo } from '../types';
import styles from './CustomerHeaderCard.less';
import LeadName from '@/components/Lead/LeadName';
import { LeadDetailsModel } from '@/typings/models/Lead';
import PhoneNumberFormat from '@/components/format/PhoneNumberFormat';

const { Text } = Typography;

export interface CustomerHeaderCardProps {
  customer: CustomerInfo;
  lead: LeadDetailsModel;
  onEmail?: () => void;
  onCall?: () => void;
  onSchedule?: () => void;
  onPrint?: () => void;
}

const CustomerHeaderCard: React.FC<CustomerHeaderCardProps> = ({
                                                                 customer,
                                                                 lead,
                                                                 onEmail,
                                                                 onCall,
                                                                 onSchedule,
                                                               }) => {

  return (
    <div className={styles.customerHeaderCard}>
      <div className={styles.headerContent}>
        <div className={styles.customerInfo}>
          <div className={styles.avatarContainer}>
            <LeadName lead={lead} justAvatar />
          </div>
          <div className={styles.details}>
            <h2 className={styles.name}>
              <LeadName hideAvatar readonly lead={lead} />
            </h2>
            <div className={styles.contactInfo}>
              {customer?.email && (
                <Text
                  className={styles.copyableText}
                  copyable={{
                    text: customer?.email,
                  }}
                >
                  <div className={styles.contactItem}>
                    <MailOutlined className={styles.icon} />
                    <span>{customer?.email}</span>
                  </div>
                </Text>
              )}
              {customer?.phone && (
                <Text
                  className={styles.copyableText}
                  copyable={{ text: customer?.phone }}
                >
                  <div className={styles.contactItem}>
                    <PhoneNumberFormat phoneNumber={customer?.phone} variant="link" />
                  </div>
                </Text>
              )}
            </div>
            <div className={styles.actions}>
              <Space>
                {onEmail && lead?.customer?.email && (
                  <Button
                    icon={<MailOutlined />}
                    onClick={onEmail}
                  />
                )}
                {onCall && lead?.customer?.phone && (
                  <Button
                    icon={<PhoneOutlined />}
                    onClick={onCall}
                  />
                )}
                {onSchedule && (
                  <Button
                    icon={<CalendarOutlined />}
                    onClick={onSchedule}
                  />
                )}
              </Space>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerHeaderCard;
